import { PlaneBufferGeometry } from 'three'

export default (width: number, height: number) => {
  return new PlaneBufferGeometry(width, height, 10, 20);
}
